import { IGroupedEvent } from '@sdk/contracts';
import { dateProvider } from '@utils';
import { useNavigate } from 'react-router-dom';

import { EventItem } from './EventItem';
import {
  DateWrapper,
  DateMonthWrapper,
  EventsWrapper,
  DateDayWrapper,
  Wrapper,
  ContentWrapper
} from './GroupEventsByDate.styles';

type GroupEventsByDateProps = {
  events: IGroupedEvent[];
};

export const GroupEventsByDate: React.FC<GroupEventsByDateProps> = ({ events }) => {
  const navigateTo = useNavigate();

  const goToEvent = (eventId: string) => {
    navigateTo(`/content/calendar/${eventId}`);
  };

  const isToday = (date: Date) => {
    const today = dateProvider.now();
    return dateProvider.isSameDay(date, today);
  };

  return (
    <>
      {events.map(group => (
        <ContentWrapper key={group.dateKey}>
          <Wrapper>
            <DateWrapper $isToday={isToday(group.originalDate)}>
              <DateDayWrapper>{dateProvider.format(group.originalDate, 'dd')}</DateDayWrapper>
              <DateMonthWrapper>
                {dateProvider.format(group.originalDate, 'MMM').toLocaleUpperCase()}
              </DateMonthWrapper>
            </DateWrapper>
            <EventsWrapper>
              {group.events.map(event => (
                <EventItem key={event._id} event={event} onClick={() => goToEvent(event._id)} />
              ))}
            </EventsWrapper>
          </Wrapper>
        </ContentWrapper>
      ))}
    </>
  );
};
